import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';

// Sepette zaten olan bir ürün tekrar eklendiğinde sorulan pencere.
// Kullanım: const secim = await ayniUrunSor(urunAdi);  // 'mevcut' | 'yeni' | null (Esc / dışarı tıklama)
const AyniUrunPenceresi = ({ urunAdi, onSec }) => {
    const [secili, setSecili] = useState('mevcut');
    const seciliRef = useRef(secili);
    seciliRef.current = secili;

    useEffect(() => {
        // Formların document üzerindeki kısayolları (Enter ile ekleme, ok tuşları) tetiklenmesin diye capture'da yakala
        const tus = (e) => {
            if (!['Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) return;
            e.preventDefault();
            e.stopPropagation();
            if (e.key === 'Enter') onSec(seciliRef.current);
            else if (e.key === 'Escape') onSec(null);
            else setSecili(s => (s === 'mevcut' ? 'yeni' : 'mevcut'));
        };
        window.addEventListener('keydown', tus, true);
        return () => window.removeEventListener('keydown', tus, true);
    }, [onSec]);

    const butonStili = (aktif, renk) => ({
        flex: 1, height: '36px', borderRadius: '5px', cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
        fontSize: '14px', fontWeight: 500, border: `1px solid ${renk}`,
        background: aktif ? renk : '#FFFFFF', color: aktif ? '#FFFFFF' : renk,
        outline: aktif ? `2px solid ${renk}55` : 'none', outlineOffset: '2px'
    });

    return (
        <div onMouseDown={(e) => { if (e.target === e.currentTarget) onSec(null); }}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 }}>
            <div style={{ width: '380px', maxWidth: 'calc(100vw - 32px)', background: '#F8F8F8', border: '1px solid #C2C2C2', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.25)', padding: '20px', fontFamily: 'Poppins, sans-serif' }}>
                <div style={{ fontWeight: 600, fontSize: '15px', marginBottom: '8px' }}>Bu ürün sepette zaten var</div>
                <div style={{ fontSize: '13px', color: '#555', marginBottom: '6px' }}>
                    <strong>{urunAdi}</strong>
                </div>
                <div style={{ fontSize: '12px', color: '#777', marginBottom: '18px', lineHeight: 1.5 }}>
                    <strong>Mevcuta Ekle:</strong> adet mevcut kaleme eklenir.<br />
                    <strong>Yeni Ürün:</strong> ayrı kalem olarak eklenir, farklı fiyat verebilirsiniz.
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button type="button" autoFocus onMouseEnter={() => setSecili('mevcut')} onClick={() => onSec('mevcut')} style={butonStili(secili === 'mevcut', '#4A6FA5')}>Mevcuta Ekle</button>
                    <button type="button" onMouseEnter={() => setSecili('yeni')} onClick={() => onSec('yeni')} style={butonStili(secili === 'yeni', '#2E8B57')}>Yeni Ürün</button>
                </div>
            </div>
        </div>
    );
};

export const ayniUrunSor = (urunAdi) => new Promise((resolve) => {
    const oncekiOdak = document.activeElement;
    const kap = document.createElement('div');
    document.body.appendChild(kap);
    const root = createRoot(kap);
    let bitti = false;
    const onSec = (secim) => {
        if (bitti) return;
        bitti = true;
        resolve(secim);
        // Kendi olay işleyicisinin içinden root'u senkron kapatmamak için bir sonraki tura bırak
        setTimeout(() => {
            root.unmount();
            kap.remove();
            if (oncekiOdak && document.contains(oncekiOdak)) oncekiOdak.focus();
        }, 0);
    };
    root.render(<AyniUrunPenceresi urunAdi={urunAdi} onSec={onSec} />);
});
